export default __webpack_public_path__ + "e3b9dfabbef57289be7880005a06b108.svg";